import React, {} from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { Row, Col } from '@lockerpm/design';
import { } from "@ant-design/icons";

import commonComponents from "../../../components/common";
import General from "./components/information/General";

const Information = () => {
  const { PageHeader } = commonComponents;
  const { t } = useTranslation();
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)
  return (
    <div className="information layout-content">
      <PageHeader
        title={t('information.title')}
        subtitle={t('information.description')}
        actions={[]}
      />
      <Row gutter={[12, 12]}>
        <Col xl={24} md={24}>
          <General
            className={'mt-6'}
            workspace={selectedWorkspace}
          />
        </Col>
      </Row>
    </div>
  );
}

export default Information;